/**
* Logos Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logos-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.splide--logos-marquee' ).length ) {
        new Splide( '.splide--logos-marquee', {
          pagination: false,
          arrows: false,
          type: 'loop',
          autoWidth: true,
        } ).mount( {AutoScroll} );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-marquee', COMPONENT );
} )( app );
